import React from 'react';
import { Label } from 'reactstrap';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import styled from 'styled-components';
import BackButton from '../../../components/custom/BackButton';
import ActionIcon from '../../../components/custom/ActionIcon';
import VirtualTable from '../../../components/custom/VirtualTable';
import { ChoiceEmployee, MessageGroupData } from '../../../globals/interfaces';
import { AddGroupMember, DeleteGroupMember } from '.';

interface Props {
    modal: boolean;
    setModal: (state: boolean) => void;
    employees: Array<ChoiceEmployee>;
    selectedGroup: MessageGroupData | undefined;
    addGroupMember: AddGroupMember;
    deleteGroupMember: DeleteGroupMember;
}

export default function ModalAddToGroup ({
    modal,
    setModal,
    employees,
    selectedGroup,
    addGroupMember,
    deleteGroupMember
}: Props) {

    const toggle = () => setModal(!modal);

    if (!selectedGroup) return null;

    return (
        <Modal isOpen={modal} toggle={toggle} size={'lg'}>
            <ModalHeader className={'d-flex'}>
                <HeaderContainer>
                    <BackButton onClick={toggle} />
                    <h4 className={'pl-2'}>Add User</h4>
                </HeaderContainer>
            </ModalHeader>
            <ModalBody>
                <VirtualTable 
                    data={employees}
                    mapping={[{
                        name: 'Unit',
                        value: 's_unit'
                    }, {
                        name: 'First Name',
                        value: 's_first_name'
                    }, {
                        name: 'Last Name',
                        value: 's_last_name'
                    }, {
                        name: 'Job Title',
                        value: 's_job_title'
                    }, {
                        name: '',
                        value: 'fas fa-plus',
                        icon: true,
                        function: (employee: ChoiceEmployee) => addGroupMember(selectedGroup.id, employee.id)
                    }]}
                />
            </ModalBody>
            <ExpandedFooter>
                <FooterContentContainer>
                    <FooterButtonsContainer>
                        <ActionIcon type={'save'} onClick={toggle} />
                    </FooterButtonsContainer>
                </FooterContentContainer>
            </ExpandedFooter>
        </Modal>
    );
}

const HeaderContainer = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
`;

const ExpandedFooter = styled(ModalFooter)`
    width: 100%;
`;

const FooterContentContainer = styled.div`
    width: 100%;
`;

const FooterButtonsContainer = styled.div<{update?: boolean}>`
    width: 100%;
    display: flex;
    justify-content: ${p => p.update ? 'space-between' : 'flex-end'};
`;